module.exports = __webpack_public_path__ + "img/MFT白皮书_37.707bc13c.jpg";